<template>
  <div class="familias">
    <label for="familia">Familia</label>
    <select required v-model="familia" name="familia" id="familia">
      <option value="">Seleccione...</option>
      <option v-for="item in familias"
              :value="item">
        {{item.nombre | upper}}
      </option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import mixinProducto from "../mixins/mixinProducto";

  export default {
    name: "Familia",
    mixins: [mixinProducto],
    computed: {
      ...mapGetters({
        familias: "producto/familias"
      }),
      familia: {
        get() {
          return this.$store.state.producto.producto.familia
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "familia", value})
          if (value.id !== undefined){
            this.$store.dispatch("producto/getClasificacion", {field: "familiaId", value: value.id})
            this.setInicio(2, value.codigo)
          } else {
            this.$store.commit("producto/SET_CLASIFICACIONES", [])
            this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "clasificacion", value: ""})
            this.setInicio(2, "XX")
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
